import {
  hasClass,
  addClass,
  removeClass,
} from '../utilities/dom';
// import { getBreakpoint } from '../utilities/breakpoints';

export default class {
  constructor({
    container,
    trigger,
  }) {
    // Elements and class variables
    const modalElement = document.querySelector(container);
    const modalVideo = modalElement.querySelector('.video-modal__video');
    const triggers = document.querySelectorAll(trigger);
    const modalClose = document.querySelector('.video-modal__close');
    const docBody = document.querySelector('body');

    // Function to open video modal and load in iframe video
    function openVideoModal(triggerVideoID) {
      if (triggerVideoID) {
        docBody.classList.add('noscroll');
        modalVideo.innerHTML = `<iframe src="https://player.vimeo.com/video/${triggerVideoID}?quality=1080p" title="" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" data-ready="true"></iframe>`;
        if (!hasClass(modalElement, 'is--active')) {
          addClass(modalElement, 'is--active');
        }
      }
    }

    // Loop through triggers and add event listeners to send video id to modal function when clicked
    if (triggers) {
      Array.from(triggers).forEach(trig => {
        trig.addEventListener('click', event => {
          const triggerVideoID = trig.getAttribute('data-video');
          event.preventDefault();
          openVideoModal(triggerVideoID);
        });
      });
    }

    // Function to close modal when close button is clicked
    modalClose.addEventListener('click', event => {
      event.preventDefault();
      docBody.classList.remove('noscroll');
      if (hasClass(modalElement, 'is--active')) {
        removeClass(modalElement, 'is--active');
        modalVideo.innerHTML = '';
      }
    });

    // Function to close modal when escape key is clicked
    window.addEventListener('keypress', e => {
      if (e.key === 'Escape') {
        if (hasClass(modalElement, 'is--active')) {
          removeClass(modalElement, 'is--active');
          modalVideo.innerHTML = '';
          docBody.classList.remove('noscroll');
        }
      }
    });
  }
}
